import { createIcon } from './createIcon'

export const ArrowDownIcon = createIcon({
  displayName: 'ArrowDownIcon',
  viewBox: '0 0 14 14',

  path: [
    <path
      d="M7 9.66667L4.33333 7M7 9.66667V4.33333M7 9.66667L9.66667 7M13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13C10.3137 13 13 10.3137 13 7Z"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      fill="none"
    />,
  ],
})
